/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { AnyAction, createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import { getFooterUrls } from '../../util/header';
import { SET_TENANT } from '../session/actionTypes';

const slice = createSlice({
  name: 'assistants',
  initialState: {
    showInstancePicker: false,
    showPlanInfo: false,
    showUpgrade: false,
    showRestoreIA: false,
    activePanel: null,
    showAboutModal: false,
    showCreateAssistantModal: false,
    urls: {
      cloudDashboard: 'https://cloud.ibm.com',
      addUsers:
        'https://cloud.ibm.com/iam/?env_id=ibm%3Ays1%3Aus-south#/add-users',
      manageUsers:
        'https://cloud.ibm.com/iam/?env_id=ibm%3Ays1%3Aus-south#/users',
      usageBilling: 'https://cloud.ibm.com/billing/usage'
    }
  },
  reducers: {
    setShowInstancePicker(state, action) {
      state.activePanel = null;
      state.showInstancePicker = action.payload;
    },
    setShowPlanInfo(state, action) {
      state.activePanel = null;
      state.showPlanInfo = action.payload;
    },
    setShowRestoreIA(state, action) {
      state.activePanel = null;
      state.showRestoreIA = action.payload;
    },
    setActivePanel(state, action) {
      state.activePanel = action.payload;
    },
    setShowAboutModal(state, action) {
      state.showAboutModal = action.payload;
    },
    setShowCreateAssistantModal(state, action) {
      state.showCreateAssistantModal = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase<string, AnyAction>(SET_TENANT, (state, action) => {
      state.urls = _.merge({}, state.urls, getFooterUrls(action.region));
    });
  }
});

export const actions = slice.actions;
export default slice.reducer;
